@if(loading){

<div class="loader-overlay">
  <mat-spinner></mat-spinner>
</div>
}

<mat-card-content>

  <form [formGroup]="formGroup">

    <div class="borda" [innerHTML]="termo"></div>

    <mat-radio-group formControlName="aceito" aria-label="Select an option">
      <mat-radio-button value="true">{{ "conclusao.li_e_concordo_com_os_termos" | translate}}</mat-radio-button>
      <br>
      <mat-radio-button value="false"><span [ngClass]="{'red': scroll_finished}">{{ "conclusao.discordo_termo" | translate}}</span></mat-radio-button>
    </mat-radio-group>

    <div class="buttons">

      <!-- <button matButton="filled" (click)="finalizar()" [disabled]="!formGroup.valid || !aceite || !termo"   >{{ "curso.finalizar" | translate }}</button> -->
       <button matButton="filled" (click)="finalizar()" [disabled]="!formGroup.valid || !aceite"   >{{ "curso.finalizar" | translate }}</button>

    </div>

  </form>

</mat-card-content>
